import { hasRole } from "./roleNames";

export function getRoleHomePath(roles = []) {
  if (hasRole(roles, "admin")) return "/orders";
  if (hasRole(roles, "va-admin")) return "/orders";
  if (hasRole(roles, "va-distributor")) return "/distributor";
  if (hasRole(roles, "audiologist")) return "/audiologist";
  return "/access-denied";
}
